import React from 'react';

interface Props {
  className?: string;
}

const MergeShapes: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="20"
    viewBox="0 0 20 21"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M0 0.500015H13.4545V7.0455H20V20.5H6.54551V13.9545H0V0.500015ZM8.36369 12.1363V18.6818H18.1818V8.86368H11.6363V2.31819H1.81817V12.1363H8.36369Z"
      fill="currentColor"
      fillRule="evenodd"
      id="Union (Stroke)"
    />
  </svg>
);

export default MergeShapes;
